module.exports = __webpack_public_path__ + "echarge/img/mockup-wh_x2.bcaf7652.png";